import React from 'react'

import './resultSlideNewLayout.scss'
import {
  ImageComponent,
  ResultActions,
  VideoComponent,
} from './shared-components'
import { parseVideoIds } from './quiz-utils'

export const ResultSlideNewLayout = ({
  id,
  videoId,
  title,
  desc,
  link,
  linkTitle,
  image, // TODO
  quizId,
  quizHeadline,
  dropdownButtons,
  onEvent,
  socialShare,
  nextStepButton,
  resultLayout,
  // puck (BR-5451): rendered media/content nodes + card/shop-button styling
  puckMedia = null,
  puckContent = null,
  puckCardStyle = undefined,
  puckCardOverlayStyle = undefined,
  puckTitleStyle = undefined,
  puckDescStyle = undefined,
  puckContentStyle = undefined,
  puckRegionStyles = {},
  puckShopButtonClass = undefined,
  puckShopButtonStyle = undefined,
  puckShopButtonOverlayStyle = undefined,
  puckButtons = [],
}) => {
  const layoutOrientation =
    resultLayout === 'TWO_COLUMN_2024' ? 'two-column' : 'one-column'

  let videoIDArray = []
  if (videoId) {
    videoIDArray = parseVideoIds(videoId)
  }

  const imageComponent = className => (
    <div
      className={`result_slide_image_wrapper ${className}`}
      style={className === 'mobile' ? puckRegionStyles.media : undefined}
    >
      {puckMedia ?? (
        <>
          <VideoComponent
            videoId={videoId}
            videoIDs={videoIDArray}
            onEvent={onEvent}
            autoPlay={false}
            quizHeadline={quizHeadline}
            quizId={quizId}
          />
          <ImageComponent
            className="result_slide_image_container"
            imageClassName="result_slide_image"
            image={image}
          />
        </>
      )}
    </div>
  )

  return (
    <div className="result_slide_container" style={{ width: '100%' }}>
      <div
        className={`result_slide ${layoutOrientation}`}
        // position:relative only when the border overlay needs an anchor —
        // .result_slide has overflow:hidden, and unconditionally positioning
        // it turned it into the containing block of the absolutely-positioned
        // next-activity arrow, clipping the arrow (puck and non-puck alike)
        style={
          puckCardOverlayStyle
            ? { position: 'relative', ...(puckCardStyle ?? {}) }
            : puckCardStyle
        }
      >
        {puckCardOverlayStyle && (
          <div aria-hidden style={puckCardOverlayStyle} />
        )}
        {imageComponent()}
        <div className="result_slide_content" style={puckContentStyle}>
          {imageComponent('mobile')}
          <div
            className="button-wrapper"
            style={{ width: '100%', ...(puckRegionStyles.buttons ?? {}) }}
          >
            {puckButtons?.length > 0 && (
              <div
                className="result-multibuttons"
                style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: '15px',
                  width: '100%',
                }}
              >
                {puckButtons.map((b, bi) => (
                  <React.Fragment key={bi}>{b}</React.Fragment>
                ))}
              </div>
            )}
            {(link || (dropdownButtons && dropdownButtons.length > 0)) && (
              <ResultActions
                link={link}
                linkTitle={linkTitle}
                id={id}
                title={title}
                quizId={quizId}
                quizHeadline={quizHeadline}
                onEvent={onEvent}
                dropdownButtons={dropdownButtons}
                className="result-actions"
                shopButtonClassName={puckShopButtonClass}
                shopButtonStyle={puckShopButtonStyle}
                shopButtonOverlayStyle={puckShopButtonOverlayStyle}
              />
            )}
          </div>
          <h2
            className="result_slide_content_title"
            aria-label={title}
            style={{ ...(puckTitleStyle ?? {}), ...(puckRegionStyles.title ?? {}) }}
            dangerouslySetInnerHTML={{ __html: title }}
          ></h2>
          <div className="description" style={puckRegionStyles.desc}>
            <div
              aria-label={desc}
              style={puckDescStyle}
              dangerouslySetInnerHTML={{ __html: desc }}
            ></div>
          </div>
          {puckContent && (
            <div className="social-share" style={puckRegionStyles.content}>
              {puckContent}
            </div>
          )}
          <div className="social-share">{socialShare}</div>
        </div>
        {nextStepButton}
      </div>
    </div>
  )
}
